// @flow

import React, { useCallback, useEffect, useState } from 'react';

import { isDevelopment } from '@zapier/common-utils';
import { type Alert, Megaphone, level } from '@zapier/perf-utils';

import Overlay from './Overlay';

const MegaphoneController = () => {
  const [theAlert, setTheAlert] = useState(null);

  const alertHandler = useCallback(
    (alert: Alert) => {
      setTheAlert(alert);
    },
    [setTheAlert]
  );

  useEffect(() => Megaphone.registerHandler(alertHandler), [alertHandler]);

  return <Overlay alert={theAlert} />;
};

const SilentController = () => null;

const TheController =
  isDevelopment() && level.severity === 'fatal'
    ? MegaphoneController
    : SilentController;

export default TheController;
